var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('v-layout', {
    staticStyle: {
      "gap": "4px"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.undo
    }
  }, 'v-btn', {
    loading: _vm.loading,
    outlined: _vm.disabled
  }, false), [_c('span', [_vm._v(_vm._s(_vm.disabled ? "취소완료" : "취소하기"))])])], 1) : _c('span', [_vm._v(" - ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }